import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/notifications/lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
